<template>
  <p
    :class="
      `${align} ${size ? 'size-x' + size : ''} ${highlighted ? 'paragraph--highlighted' : ''}`
    "
  >
    {{ text }}
  </p>
</template>

<script>
import { existsInArray } from '@/helpers';

export default {
  name: 'Paragraph',
  props: {
    text: {
      required: true,
      type: String,
    },
    align: {
      default: 'justify',
      type: String,
    },
    size: {
      default: null,
      type: Number,
      validator: (value) => existsInArray(value, [1, 2, 3]),
    },
    highlighted: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/typography';
@import '../scss/variables';

$sizes: 1.5, 1.8;

p {
  @extend %align;
  @include getSizes($base-font-size, $base-line-height, $sizes);

  &.paragraph--highlighted {
    color: $highlight-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Paragraph.vue